import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
// import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
import DarkMode from "@material-ui/icons/Brightness4";
import LightMode from "@material-ui/icons/Brightness7";
import Security from "@material-ui/icons/Security";
// import Dot from '@material-ui/icons/FiberManualRecord';
// core components
import headerStyle from "./header-style";
import SearchBox from '../../../components/SearchBox';
import CustomButton from "../../../components/CustomButton";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
            sticky: false,
            scroll: 0,
        };
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        // this.headerColorChange = this.headerColorChange.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }
    handleScroll() {
        this.setState({ scroll: window.scrollY });
    }
    handleDrawerToggle() {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }
    componentDidMount() {
        // if (this.props.changeColorOnScroll) {
        //     window.addEventListener("scroll", this.headerColorChange);
        // }
        window.addEventListener('scroll', this.handleScroll);
        this.getPosition();
        // this.drawCanvas();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.history !== this.props.history || prevProps.notHomePage !== this.props.notHomePage)
            this.getPosition();
    }
    getPosition = () => {
        setTimeout(() => {
            const el = document.body.getElementsByTagName("header")[0];
            if (el && (this.props.notHomePage || this.props.loginPage))
                this.setState({ top: el.offsetTop, height: el.offsetHeight }, () => {
                    const { setHeaderHeight } = this.props;
                    if (setHeaderHeight)
                        setHeaderHeight(el.offsetHeight);
                });
            else if (el && !this.props.notHomePage) {
                this.setState({ top: window.scrollY + window.innerHeight - el.offsetHeight, height: el.offsetHeight }, () => {
                    const { setHeaderHeight } = this.props;
                    if (setHeaderHeight)
                        setHeaderHeight(el.offsetHeight);
                });
            }
        }, 100);
    }
    headerColorChange() {
        const { classes, color, changeColorOnScroll } = this.props;
        if (this.state.scroll >= this.state.top) {
            document.body
                .getElementsByTagName("header")[0]
                .classList.remove(classes[color]);
            document.body
                .getElementsByTagName("header")[0]
                .classList.add(classes[changeColorOnScroll.color]);
        } else {
            document.body
                .getElementsByTagName("header")[0]
                .classList.add(classes[color]);
            document.body
                .getElementsByTagName("header")[0]
                .classList.remove(classes[changeColorOnScroll.color]);
        }
    }
    componentWillUnmount() {
        // if (this.props.changeColorOnScroll) {
        //     window.removeEventListener("scroll", this.headerColorChange);
        // }
        window.removeEventListener('scroll', this.handleScroll);
    }
    // drawCanvas = () => {
    //     const lightCanvas = document.getElementById('lightCanvas');
    //     const lctx = lightCanvas.getContext('2d');

    //     lctx.strokeStyle = "#7a0026";
    //     lctx.beginPath(); 
    //     lctx.moveTo(4, 20); 
    //     lctx.lineTo(25, 4); 
    //     lctx.stroke(); 

    //     lctx.beginPath(); 
    //     lctx.moveTo(22, 4); 
    //     lctx.lineTo(40, 45); 
    //     lctx.stroke(); 

    //     lctx.beginPath(); 
    //     lctx.moveTo(37, 45); 
    //     lctx.lineTo(45, 20); 
    //     lctx.stroke(); 

    //     lctx.beginPath(); 
    //     lctx.moveTo(40, 43); 
    //     lctx.lineTo(87, 32); 
    //     lctx.stroke(); 

    //     lctx.beginPath(); 
    //     lctx.moveTo(86, 32); 
    //     lctx.lineTo(103, 19); 
    //     lctx.stroke(); 

    //     const darkCanvas = document.getElementById('darkCanvas');
    //     const dctx = darkCanvas.getContext('2d');

    //     dctx.strokeStyle = "white";
    //     dctx.beginPath(); 
    //     dctx.moveTo(4, 20); 
    //     dctx.lineTo(25, 4); 
    //     dctx.stroke(); 

    //     dctx.beginPath(); 
    //     dctx.moveTo(22, 4); 
    //     dctx.lineTo(40, 45); 
    //     dctx.stroke(); 

    //     dctx.beginPath(); 
    //     dctx.moveTo(37, 45); 
    //     dctx.lineTo(45, 20); 
    //     dctx.stroke(); 

    //     dctx.beginPath(); 
    //     dctx.moveTo(40, 43); 
    //     dctx.lineTo(87, 32); 
    //     dctx.stroke(); 

    //     dctx.beginPath(); 
    //     dctx.moveTo(86, 32); 
    //     dctx.lineTo(103, 19); 
    //     dctx.stroke(); 
    // }
    render() {
        const {
            classes,
            // color,
            rightLinks,
            midLinks,
            leftLinks,
            // brand,
            // fixed,
            // absolute,
            // routes,
            // triggerSearch,
            // location,
            image,
            darkImage,
            notHomePage,
            isFullScreen,
            loginPage,
            hideHeaderSearhBox,
            cookies,
            authenticated,
            registerPage,
            ...others
        } = this.props;
        const searchPage = others.searchPage ? others.searchPage : false;
        const appBarClasses = classNames({
            [classes.appBar]: true,
            [classes.isFullScreen]: isFullScreen,
            // [classes[color]]: color,
            [classes.topAppBar]: true,
            // [classes.topLightColor]: (notHomePage && cookies.get('themeColor') === 'light') || (this.state.scroll >= 100 && cookies.get('themeColor') === 'light'),
            // [classes.topDarkColor]: (notHomePage && cookies.get('themeColor') === 'dark') || (this.state.scroll >= 100 && cookies.get('themeColor') === 'dark'),
            [classes.topBlueColor]: true
        });
        const searchBar = classNames({
            [classes.searchBar]: true,
            [classes.searchResultBar]: searchPage,
            [classes.newsPageBar]: hideHeaderSearhBox,
        })
        const tooltipClass = {
            tooltip: classes.tooltip,
            arrow: classes.tooltipArrow,
        };
        const onClick = () => {
            const color = cookies.get('themeColor');
            if (color === 'light')
                cookies.set('themeColor', 'dark', { path: '/' });
            else if (color === 'dark')
                cookies.set('themeColor', 'light', { path: '/' });
        }
        const brandComponent = (
            <Button
                className={this.state.scroll >= 100 ? classes.newTitle : classes.title}
                href={"/home"}
                disableRipple
                style={{ overflow: "hidden" }}
            >
                {cookies.get('themeColor') === 'dark' ? <img src={darkImage} width={"240px"} alt="DIBots Logo" /> : <img src={image} width={"240px"} alt="DIBots Logo" />}
                {/* <img src={image} width={"200px"} alt="DIBots Logo" /> */}
                {/* {(loginPage && cookies.get('themeColor') === 'dark') || (cookies.get('themeColor') === 'dark' && this.state.scroll >= 100) ?  */}

                {/* <div className={classes.wordsLogo}>
                    <Dot className={cookies.get('themeColor') === 'dark' ? classes.darkDotLogo : classes.dotLogo} style={{ fontSize: "8px", left: "0px", top: "16px" }} />
                    <Dot className={cookies.get('themeColor') === 'dark' ? classes.darkDotLogo : classes.dotLogo} style={{ fontSize: "14px", left: "15px" }} />
                    <Dot className={cookies.get('themeColor') === 'dark' ? classes.darkDotLogo : classes.dotLogo} style={{ fontSize: "18px", left: "30px", top: "32px" }} />
                    <Dot className={cookies.get('themeColor') === 'dark' ? classes.darkDotLogo : classes.dotLogo} style={{ fontSize: "6px", left: "42px", top: "17px" }} />
                    <Dot className={cookies.get('themeColor') === 'dark' ? classes.darkDotLogo : classes.dotLogo} style={{ fontSize: "10px", left: "79px", top: "29px" }} />
                    <Dot className={cookies.get('themeColor') === 'dark' ? classes.darkDotLogo : classes.dotLogo} style={{ fontSize: "5px", left: "101px", top: "16px" }} />
                    <canvas id="lightCanvas" className={classes.dotLogo} style={{ display: cookies.get('themeColor') === 'dark' ? "none" : "block" }} />
                    <canvas id="darkCanvas" className={classes.dotLogo} style={{ display: cookies.get('themeColor') === 'dark' ? "block" : "none" }} />
                    {(loginPage && cookies.get('themeColor') === 'dark') || (cookies.get('themeColor') === 'dark') ? 
                        (<span style={{ color: "white", textTransform: "none", marginLeft: "50px", letterSpacing: "4px" }}>DIBots</span>) : 
                        (<>
                            <span style={{ color: "#003663", textTransform: "none", marginLeft: "50px", letterSpacing: "4px" }}>DI</span>
                            <span style={{ textTransform: "none", letterSpacing: "4px" }}>Bots</span>
                        </>)
                    }
                    <div style={{ fontSize: "9px", position: "absolute", left: "53px", top: "44px", color: cookies.get('themeColor') === 'dark' ? "white" : "#003663", letterSpacing: "2px", textTransform: "none" }}>Data Intelligence Solutions</div>
                </div> */}
            </Button>
        );
        return (
            <AppBar className={appBarClasses}>
                <Toolbar className={classes.container}>
                    {leftLinks !== undefined ? brandComponent : null}
                    <div className={classes.flex}>
                        {leftLinks !== undefined ? (
                            <Hidden smDown implementation="css">
                                {leftLinks}
                            </Hidden>
                        ) : (
                            brandComponent
                        )}
                    </div>
                    <div className={searchBar}>
                        {/* {!loginPage && (this.state.scroll >= 200 || (notHomePage && !searchPage)) ? */}
                        {!loginPage && ((authenticated && this.state.scroll >= 200) || (notHomePage && !searchPage)) ?
                            <SearchBox {...others} authenticated={authenticated} location hidden search={true} themeColor={cookies.get('themeColor')} /> : ""}
                    </div>
                    <div className={classes.flex}>
                        <Hidden smDown implementation="css">
                            <div>{midLinks}</div>
                        </Hidden>
                    </div>
                    {rightLinks ?
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={this.handleDrawerToggle}
                            style={{ "marginRight": "16px" }}
                        >
                            <Menu />
                        </IconButton> : ""
                    }
                    {loginPage ? <div>
                        {/* <ListItem className={classes.listItem}>
                            <Button
                                href="/register"
                                color="inherit"
                                className={classes.navLink}
                            >
                                <Security className={classes.icons} />
                                register
                            </Button>
                        </ListItem> */}
                        <ListItem className={classes.listItem}>
                            <Tooltip classes={tooltipClass} arrow title={"Toggle light/dark theme"}>
                                <CustomButton
                                    color="inherit"
                                    onClick={onClick}
                                    className={classes.navLink}
                                >
                                    {cookies.get('themeColor') === 'light' ? <DarkMode className={classes.icons} /> : <LightMode className={classes.icons} />}
                                </CustomButton>
                            </Tooltip>
                        </ListItem></div> : ""}
                    {registerPage ? <div>
                        <ListItem className={classes.listItem}>
                            <Button
                                href="/loginPage"
                                color="inherit"
                                className={classes.navLink}
                            >
                                <Security className={classes.icons} />
                                login
                            </Button>
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            <Tooltip classes={tooltipClass} arrow title={"Toggle light/dark theme"}>
                                <CustomButton
                                    color="inherit"
                                    onClick={onClick}
                                    className={classes.navLink}
                                >
                                    {cookies.get('themeColor') === 'light' ? <DarkMode className={classes.icons} /> : <LightMode className={classes.icons} />}
                                </CustomButton>
                            </Tooltip>
                        </ListItem></div> : ""}
                </Toolbar>
                <Hidden lgUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={"right"}
                        open={this.state.mobileOpen}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        onClose={this.handleDrawerToggle}
                    >
                        <div className={classes.appResponsive}>
                            {leftLinks}
                            {
                                !loginPage && authenticated && (this.state.scroll >= this.state.top || (notHomePage && !others.searchPage)) ?
                                    <SearchBox {...others} authenticated={authenticated} small search={true} themeColor={cookies.get('themeColor')} />
                                    : ""
                            }
                            <div className={classes.smallLinks}>
                                <div className={classes.hideLinks}>
                                    {midLinks}
                                </div>
                                {rightLinks}
                            </div>
                        </div>
                    </Drawer>
                </Hidden>
            </AppBar>
        );
    }
}

Header.defaultProp = {
    color: "white"
};

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",
        "white",
        "rose",
        "dark",
        "blue"
    ]),
    rightLinks: PropTypes.node,
    leftLinks: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,
    // this will cause the sidebar to change the color from
    // this.props.color (see above) to changeColorOnScroll.color
    // when the window.pageYOffset is heigher or equal to
    // changeColorOnScroll.height and then when it is smaller than
    // changeColorOnScroll.height change it back to
    // this.props.color (see above)
    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
            "primary",
            "info",
            "success",
            "warning",
            "danger",
            "transparent",
            "white",
            "rose",
            "dark"
        ]).isRequired
    })
};

export default withStyles(headerStyle)(Header);
